import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Action} from '@ngrx/store';

import * as commonActions from '../actions/common.actions';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/mergeMap';
import {Actions, Effect} from '@ngrx/effects';
import {BrandModel, BrandmodelModel, FollowUpStatus, BranchModel, ReferenceModel} from '../../model/index';
import {CommonService, AuthService} from '../../services/index';

@Injectable()
export class CommonEffects {

    @Effect()
    isAuth: Observable<Action> = this.actions$
        .ofType(commonActions.IS_AUTH) /* When [Contacts] LOAD ALL action is dispatched */
        //.map((action: commonActions.IsAuth) => action.payload)
        .startWith(new commonActions.IsAuth())
        .switchMap((params) =>
            this.authService.isauth(params) /* Hit the Contacts Index endpoint of our REST API */
                /* Dispatch LoadAllSuccess action to the central store with contact list returned by the backend as payload*/
                /* 'Contacts Reducers' will take care of the rest */
                .map((auth: any[]) => new commonActions.IsAuthSuccess(auth))

        );

    @Effect()
    loadAllBrand$: Observable<Action> = this.actions$
        .ofType(commonActions.LOAD_ALL_BRAND) /* When [Contacts] LOAD ALL action is dispatched */
        .map((action: commonActions.LoadAllBrand) => action.payload)
        //.startWith(new commonActions.LoadAllBrand())
        .switchMap((params) =>
            this.commonService.getBrandList() /* Hit the Contacts Index endpoint of our REST API */
                /* Dispatch LoadAllSuccess action to the central store with contact list returned by the backend as payload*/
                /* 'Contacts Reducers' will take care of the rest */
                .map((brandlist: BrandModel[]) => new commonActions.LoadAllBrandSuccess(brandlist))
        );

    @Effect()
    loadAllBrandModel$: Observable<Action> = this.actions$
        .ofType(commonActions.LOAD_ALL_BRAND_MODEL) /* When [Contacts] LOAD ALL action is dispatched */
        .map((action: commonActions.LoadAllBrandModel) => action.payload)
        //.startWith(new commonActions.LoadAllBrandModel())
        .switchMap((params) =>
            this.commonService.getBrandModelList() /* Hit the Contacts Index endpoint of our REST API */
                /* Dispatch LoadAllSuccess action to the central store with contact list returned by the backend as payload*/
                /* 'Contacts Reducers' will take care of the rest */
                .map((brandModelList: BrandmodelModel[]) => new commonActions.LoadAllBrandModelSuccess(brandModelList))
        );

    @Effect()
    loadAllFollowUpStatus$: Observable<Action> = this.actions$
        .ofType(commonActions.LOAD_ALL_FOLLOWUP_STATUS) /* When [Contacts] LOAD ALL action is dispatched */
        .map((action: commonActions.LoadAllFollowUpStatus) => action.payload)
        //.startWith(new commonActions.LoadAllFollowUpStatus())
        .switchMap((params) =>
            this.commonService.getFollowUpStatusList(params) /* Hit the Contacts Index endpoint of our REST API */
                /* Dispatch LoadAllSuccess action to the central store with contact list returned by the backend as payload*/
                /* 'Contacts Reducers' will take care of the rest */
                .map((followUpList: FollowUpStatus[]) => new commonActions.LoadAllFollowUpStatusSuccess(followUpList))

        );

    @Effect()
    loadAllBranch$: Observable<Action> = this.actions$
        .ofType(commonActions.LOAD_ALL_BRANCH) /* When [Contacts] LOAD ALL action is dispatched */
        .map((action: commonActions.LoadAllBranch) => action.payload)
        //.startWith(new commonActions.LoadAllBranch())
        .switchMap((params) =>
            this.commonService.getBranchList() /* Hit the Contacts Index endpoint of our REST API */
                /* Dispatch LoadAllSuccess action to the central store with contact list returned by the backend as payload*/
                /* 'Contacts Reducers' will take care of the rest */
                .map((branchList: BranchModel[]) => new commonActions.LoadAllBranchSuccess(branchList))
        );

        @Effect()
    loadAllReference$: Observable<Action> = this.actions$
        .ofType(commonActions.LOAD_ALL_REFERENCE) /* When [Contacts] LOAD ALL action is dispatched */
        .map((action: commonActions.LoadAllReference) => action.payload)
        //.startWith(new commonActions.LoadAllBranch())
        .switchMap((params) =>
            this.commonService.getReferenceList() /* Hit the Contacts Index endpoint of our REST API */
                /* Dispatch LoadAllSuccess action to the central store with contact list returned by the backend as payload*/
                /* 'Contacts Reducers' will take care of the rest */
                .map((referenceList: ReferenceModel[]) => new commonActions.LoadAllReferenceSuccess(referenceList))
        );

    constructor(
        private actions$: Actions,
        private commonService: CommonService,
        private authService: AuthService
    ) { }


}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/store/effects/common.effects.ts